import AdminLayout from '@/components/admin/AdminLayout';
import { Settings, Shield, Bell, Database, Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const AdminSettings = () => {
    return (
        <AdminLayout>
            <div className="space-y-10">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                    <div>
                        <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tighter">Admin Settings</h2>
                        <p className="text-slate-500 font-medium text-sm">Manage your website settings and security here.</p>
                    </div>
                    <Button className="btn-gold h-14 rounded-2xl px-8 text-[10px] font-black uppercase tracking-widest shadow-premium" onClick={() => toast.success('Settings Saved')}>
                        <Save className="w-4 h-4 mr-2" />
                        Save Settings
                    </Button>
                </div>

                <div className="grid lg:grid-cols-2 gap-8">
                    {/* Security Section */}
                    <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-sm space-y-8">
                        <div className="flex items-center gap-4 pb-6 border-b border-slate-100">
                            <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center border border-blue-100">
                                <Shield className="w-6 h-6 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight">Security</h3>
                        </div>

                        <div className="space-y-6">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">Admin Email</label>
                                <Input defaultValue="admin@ratchagananalysis.com" className="h-12 rounded-xl border-slate-200" />
                            </div>
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">Admin Password</label>
                                <Input type="password" placeholder="••••••••" className="h-12 rounded-xl border-slate-200" />
                            </div>
                        </div>
                    </div>

                    {/* System Section */}
                    <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100 shadow-sm space-y-8">
                        <div className="flex items-center gap-4 pb-6 border-b border-slate-100">
                            <div className="w-12 h-12 rounded-2xl bg-amber-50 flex items-center justify-center border border-amber-100">
                                <Settings className="w-6 h-6 text-amber-600" />
                            </div>
                            <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight">Site Settings</h3>
                        </div>

                        <div className="space-y-6">
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">Site Status</label>
                                <select className="w-full h-12 px-4 bg-white border border-slate-200 rounded-xl text-sm font-medium outline-none focus:border-accent">
                                    <option>Live</option>
                                    <option>Maintenance Mode</option>
                                    <option>Testing Mode</option>
                                </select>
                            </div>
                            <div className="space-y-2">
                                <label className="text-[10px] font-black uppercase tracking-widest text-slate-400">Auto Backup</label>
                                <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100">
                                    <span className="text-xs font-bold text-slate-600 uppercase tracking-widest">Daily Backup</span>
                                    <div className="w-12 h-6 bg-accent rounded-full relative">
                                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default AdminSettings;
